<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<div class="account-page">
	<nav-bar-account></nav-bar-account>
	<!--<nav-bar-account-pages></nav-bar-account-pages>-->

	<!-- Page Content -->
	<div class="content-wrapper">
		<div class="content">
			<router-outlet></router-outlet>
		</div>
	</div>

	<!-- Footer -->
	<legalese></legalese>
</div>
